<script setup>
import {onBeforeUnmount, onMounted, ref} from 'vue'
import {useI18n} from '@/i18n'

const {t} = useI18n()
const year = new Date().getFullYear()
const showBackToTop = ref(false)

function updateBackToTop() {
  showBackToTop.value = window.scrollY > 500
}

function backToTop() {
  window.scrollTo({top: 0, behavior: 'smooth'})
}

onMounted(() => {
  updateBackToTop()
  window.addEventListener('scroll', updateBackToTop, {passive: true})
})

onBeforeUnmount(() => window.removeEventListener('scroll', updateBackToTop))
</script>

<template>
  <footer class="mkt-footer">
    <div class="mkt-shell mkt-footer-grid">
      <div class="mkt-footer-brand">
        <a class="mkt-brand is-footer" href="/" aria-label="TPA Housing">
          <img src="/images/tpa2.png" alt="" width="82" height="36">
          <span><strong>TPA</strong> HOUSING<small>STEEL BUILDING SYSTEMS</small></span>
        </a>
        <p>{{ t('marketing.footer.description') }}</p>
        <div class="mkt-footer-socials">
          <a href="https://www.facebook.com/profile.php?id=100083074701518" target="_blank" rel="noopener" aria-label="Facebook"><i class="mdi mdi-facebook"></i></a>
          <a href="https://www.linkedin.com/company/84045662/admin/" target="_blank" rel="noopener" aria-label="LinkedIn"><i class="mdi mdi-linkedin"></i></a>
          <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw" target="_blank" rel="noopener" aria-label="YouTube"><i class="mdi mdi-youtube-play"></i></a>
        </div>
      </div>
      <div class="mkt-footer-column">
        <h2>{{ t('marketing.footer.explore') }}</h2>
        <a href="/products">{{ t('nav.products') }}</a>
        <a href="/projects">{{ t('nav.projects') }}</a>
        <a href="/videos">{{ t('nav.videos') }}</a>
        <a href="/3d-models">{{ t('marketing.models.nav') }}</a>
        <a href="/about">{{ t('nav.about') }}</a>
        <a href="/blogs">{{ t('nav.blogs') }}</a>
      </div>
      <div class="mkt-footer-column mkt-footer-contact">
        <h2>{{ t('marketing.footer.contact') }}</h2>
        <a href="tel:+8613929160928"><i class="mdi mdi-phone" aria-hidden="true"></i><span>+86 139 2916 0928</span></a>
        <a href="mailto:ray.chan@tpa-prefabhouse.com"><i class="mdi mdi-email-outline" aria-hidden="true"></i><span>ray.chan@tpa-prefabhouse.com</span></a>
        <a href="https://api.whatsapp.com/send?phone=8613929160928" target="_blank" rel="noopener"><i class="mdi mdi-whatsapp" aria-hidden="true"></i><span>{{ t('marketing.shared.whatsapp') }}</span></a>
        <a href="https://api.whatsapp.com/send?phone=8613929163028" target="_blank" rel="noopener"><i class="mdi mdi-whatsapp" aria-hidden="true"></i><span>{{ t('marketing.shared.whatsapp') }}: +86 139 2916 3028</span></a>
        <p><i class="mdi mdi-map-marker-outline" aria-hidden="true"></i><span>Foshan, Guangdong, China</span></p>
      </div>
      <div class="mkt-footer-cta">
        <span>{{ t('marketing.home.inquiry.eyebrow') }}</span>
        <h2>{{ t('marketing.home.inquiry.title') }}</h2>
        <a class="mkt-button mkt-button-accent" href="/contact">{{ t('marketing.shared.quote') }}<i class="mdi mdi-arrow-right"></i></a>
      </div>
    </div>
    <div class="mkt-footer-bottom">
      <div class="mkt-shell">
        <p>© {{ year }} {{ t('marketing.footer.rights') }}</p>
        <a href="/privacy_policy">{{ t('marketing.footer.privacy') }}</a>
      </div>
    </div>
    <div class="mkt-floating-actions">
      <a class="mkt-floating-whatsapp" href="https://api.whatsapp.com/send?phone=8613929160928"
         target="_blank" rel="noopener" data-phone="+86 139 2916 0928"
         :aria-label="`${t('marketing.shared.whatsapp')} +86 139 2916 0928`">
        <i class="mdi mdi-whatsapp" aria-hidden="true"></i>
      </a>
      <a class="mkt-floating-whatsapp" href="https://api.whatsapp.com/send?phone=8613929163028"
         target="_blank" rel="noopener" data-phone="+86 139 2916 3028"
         :aria-label="`${t('marketing.shared.whatsapp')} +86 139 2916 3028`">
        <i class="mdi mdi-whatsapp" aria-hidden="true"></i>
      </a>
      <button v-show="showBackToTop" class="mkt-back-to-top" type="button"
              :title="t('marketing.shared.backToTop')" :aria-label="t('marketing.shared.backToTop')"
              @click="backToTop">
        <i class="mdi mdi-chevron-up" aria-hidden="true"></i>
      </button>
    </div>
  </footer>
</template>
